import { render, staticRenderFns } from "./PptImageAttr.vue?vue&type=template&id=b20cb0ca&"
import script from "./PptImageAttr.vue?vue&type=script&lang=js&"
export * from "./PptImageAttr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("I:\\web-project\\dream\\tools\\dsf-product-ppt\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b20cb0ca')) {
      api.createRecord('b20cb0ca', component.options)
    } else {
      api.reload('b20cb0ca', component.options)
    }
    module.hot.accept("./PptImageAttr.vue?vue&type=template&id=b20cb0ca&", function () {
      api.rerender('b20cb0ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "pc/components/attr/PptImageAttr.vue"
export default component.exports